import { useLocation } from 'react-router-dom';

// Utility function to get URL parameters
export const useQueryParams = () => {
  const location = useLocation();
  return new URLSearchParams(location.search);
};

// Utility function to generate a random string with a length between 43 and 128 characters
export const generateRandomString = (minLength = 43, maxLength = 128) => {
  // Ensure the length is within the valid range
  const length = Math.max(minLength, Math.min(maxLength, 128)); // Clamp the length between 43 and 128
  const bytes = new Uint8Array(length);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes)
    .map(byte => byte.toString(16).padStart(2, '0'))
    .join('')
    .slice(0, length); // Ensure the string length is exactly as required
};
